import { t } from 'i18next';
import { AxiosError } from 'axios';
import { enqueueSnackbar } from 'notistack';

const backendMessages: Record<string, string> = {
  'billing.invoices.backend-validation.attachment-content-type-not-supported': 'Csak PDF formátumú számla tölthető fel.',
  'billing.invoices.backend-validation.attachment-required': 'A számlafájl kiválasztása kötelező.',
  'billing.invoices.backend-validation.attachment-too-large': 'A számlafájl mérete legfeljebb 10 MB lehet.',
  'billing.invoices.backend-validation.invoice-already-uploaded-for-tig': 'Ehhez a TIG-hez már tartozik feltöltött számla.',
  'billing.invoices.backend-validation.must-be-received': 'Csak beérkezett számla jelölhető kifizetettként.',
  'billing.invoices.backend-validation.only-received-invoice-can-be-deleted': 'Csak a saját, még nem kifizetett számla törölhető.',
  'billing.tigs.backend-validation.not-all-timesheets-approved': 'A TIG csak az összes kapcsolódó munkaidő jóváhagyása után állítható ki.',
  'billing.tigs.backend-validation.tig-already-exists-for-parentSubcontractor': 'Ehhez az alvállalkozóhoz erre az időszakra már létezik TIG.',
  'billing.tigs.backend-validation.tig-already-exists-for-subcontractorNetwork': 'Ehhez az alvállalkozói körhöz erre az időszakra már létezik TIG.',
  'billing.timesheets.backend-validation.attachment-content-type-not-supported': 'Nem támogatott fájltípus. Használj PDF, kép, Excel vagy Word fájlt.',
  'billing.timesheets.backend-validation.attachment-too-large': 'A feltöltött fájl legfeljebb 10 MB lehet.',
  'billing.timesheets.backend-validation.insufficient-vacation-balance': 'Nincs elegendő tárgyévi szabadságegyenleg a megadott szabadságnapokhoz.',
  'billing.timesheets.backend-validation.invalid-month': 'Érvényes hónapot adj meg 1 és 12 között.',
  'billing.timesheets.backend-validation.invalid-vacation-days': 'A szabadságnapok száma nem lehet negatív.',
  'billing.timesheets.backend-validation.invalid-year': 'Érvényes évet adj meg 2000 és 2100 között.',
  'billing.timesheets.backend-validation.must-be-rejected': 'Csak elutasított munkaidő-nyilvántartás küldhető be újra.',
  'billing.timesheets.backend-validation.must-be-submitted': 'Csak beküldött munkaidő-nyilvántartás hagyható jóvá vagy utasítható el.',
  'billing.timesheets.backend-validation.project-assignment-required': 'A projekt-hozzárendelés kiválasztása kötelező.',
  'billing.timesheets.backend-validation.project-required': 'A projekt kiválasztása kötelező.',
  'billing.timesheets.backend-validation.request-required': 'A munkaidő-adatok megadása kötelező.',
  'billing.timesheets.backend-validation.submit-save-failed': 'A munkaidő-nyilvántartást nem sikerült menteni. Próbáld újra később.',
  'billing.timesheets.backend-validation.tig-data-incomplete': 'A TIG kiállításához hiányoznak az alvállalkozó számlázási adatai vagy a projekt megbízási adatai.',
  'billing.timesheets.backend-validation.timesheet-already-exists-for-month': 'Erre a hónapra már van beküldött munkaidő-nyilvántartás.',
  'billing.timesheets.backend-validation.work-amount-required': 'Ledolgozott óra vagy nap megadása kötelező.',
  'billing.timesheets.backend-validation.worker-not-assigned-to-project': 'A kiválasztott dolgozó nincs hozzárendelve ehhez a projekthez.',
  'billing.timesheets.backend-validation.worker-required': 'A dolgozó kiválasztása kötelező.',
  'billing.workers.backend-validation.amount-required': 'A díjazás összegének megadása kötelező, és nullánál nagyobbnak kell lennie.',
  'billing.workers.backend-validation.assignment-subject-required': 'Minden kiválasztott projekthez meg kell adni a megbízás tárgyát.',
  'billing.workers.backend-validation.bank-account-number-required': 'A bankszámlaszám megadása kötelező.',
  'billing.workers.backend-validation.bank-account-required': 'A bankszámlaszám megadása kötelező.',
  'billing.workers.backend-validation.company-registration-number-required': 'A cégjegyzékszám megadása kötelező.',
  'billing.workers.backend-validation.contract-date-required': 'A szerződés dátumának megadása kötelező.',
  'billing.workers.backend-validation.display-name-required': 'A megjelenített név megadása kötelező.',
  'billing.workers.backend-validation.effective-from-required': 'A hatálybalépés dátumának megadása kötelező.',
  'billing.workers.backend-validation.first-name-required': 'A keresztnév megadása kötelező.',
  'billing.workers.backend-validation.invalid-company-assignment': 'A megadott alvállalkozói céges hozzárendelés érvénytelen.',
  'billing.workers.backend-validation.invalid-company-project-contract': 'A dolgozó projekt-hozzárendelése nem egyezik az alvállalkozói cég szerződésével.',
  'billing.workers.backend-validation.invalid-project-assignment': 'A megadott projekt-hozzárendelés érvénytelen.',
  'billing.workers.backend-validation.invalid-worker-type': 'Érvénytelen dolgozótípus.',
  'billing.workers.backend-validation.last-name-required': 'A vezetéknév megadása kötelező.',
  'billing.workers.backend-validation.legal-name-required': 'A hivatalos név megadása kötelező.',
  'billing.workers.backend-validation.parent-subcontractor-cannot-be-self': 'Az alvállalkozó nem lehet saját maga szülő alvállalkozója.',
  'billing.workers.backend-validation.parent-subcontractor-cycle': 'Az alvállalkozói hierarchia körkörös kapcsolatot eredményezne.',
  'billing.workers.backend-validation.parent-subcontractor-invalid': 'A kiválasztott szülő alvállalkozó érvénytelen.',
  'billing.workers.backend-validation.project-required': 'Legalább egy projekt kiválasztása kötelező.',
  'billing.workers.backend-validation.rate-amount-required': 'A díjazás összegének megadása kötelező, és nullánál nagyobbnak kell lennie.',
  'billing.workers.backend-validation.rate-effective-from-must-be-after-latest': 'Az új díjazás kezdődátumának későbbinek kell lennie a legutóbbi díjazásénál.',
  'billing.workers.backend-validation.rate-type-required': 'A díjazás típusának kiválasztása kötelező.',
  'billing.workers.backend-validation.registered-seat-required': 'A székhely megadása kötelező.',
  'billing.workers.backend-validation.representative-name-required': 'A képviselő nevének megadása kötelező.',
  'billing.workers.backend-validation.sell-price-required': 'Az eladási ár megadása kötelező, és nullánál nagyobbnak kell lennie.',
  'billing.workers.backend-validation.sole-proprietor-registration-number-required': 'Az egyéni vállalkozói nyilvántartási szám megadása kötelező.',
  'billing.workers.backend-validation.subcontractor-fee-required': 'Az alvállalkozói díj megadása kötelező, és nullánál nagyobbnak kell lennie.',
  'billing.workers.backend-validation.subcontractor-legal-form-required': 'Az alvállalkozó jogi formájának kiválasztása kötelező.',
  'billing.workers.backend-validation.subcontractorNetwork-workers-have-no-vacation': 'Az alvállalkozói kör dolgozóihoz nem állítható be szabadságkeret.',
  'billing.workers.backend-validation.tax-number-required': 'Az adószám megadása kötelező.',
  'billing.workers.backend-validation.user-already-linked': 'Ehhez a felhasználóhoz már tartozik dolgozó.',
  'billing.workers.backend-validation.worker-not-assigned-to-project': 'A dolgozó nincs hozzárendelve a kiválasztott projekthez.',
  'billing.workers.backend-validation.worker-type-must-be-employee-or-subcontractor': 'A dolgozó típusa csak alkalmazott vagy alvállalkozó lehet.',
  'talent-pool.competencies.duplicate-selection': 'Egy kompetencia csak egyszer választható ki.',
  'user-management.users.backend-validation.ad-user-doesnt-exist': 'A felhasználó nem található a címtárban.',
  'user-management.users.backend-validation.duplicate-roles': 'Ugyanaz a szerepkör többször nem adható hozzá.',
  'user-management.users.backend-validation.email-not-unique': 'Ezzel az e-mail-címmel már létezik felhasználó.',
  'user-management.users.backend-validation.id-required': 'A felhasználó azonosítója kötelező.',
  'user-management.users.backend-validation.invalid-display-name': 'A megjelenített név megadása kötelező.',
  'user-management.users.backend-validation.invalid-email-address': 'Érvénytelen e-mail-cím.',
  'user-management.users.backend-validation.invalid-first-name': 'A keresztnév megadása kötelező.',
  'user-management.users.backend-validation.invalid-last-name': 'A vezetéknév megadása kötelező.',
  'user-management.users.backend-validation.user-not-found': 'A felhasználó nem található.'
};

const handledErrors = new WeakSet<object>();

const fieldLabels: Record<string, string> = {
  Amount: 'összeg',
  AnnualVacationEntitlement: 'éves szabadságkeret',
  ClientName: 'ügyfél neve',
  CompetencyIds: 'kompetenciák',
  Content: 'fájltartalom',
  ContentType: 'fájltípus',
  Currency: 'pénznem',
  DisplayName: 'megjelenített név',
  Email: 'e-mail-cím',
  FileId: 'fájl',
  FileName: 'fájlnév',
  FirstName: 'keresztnév',
  LastName: 'vezetéknév',
  Month: 'hónap',
  Name: 'név',
  PermissionIds: 'jogosultságok',
  ProjectAssignmentId: 'projekt-hozzárendelés',
  ProjectId: 'projekt',
  'Project Client Name': 'ügyfél neve',
  'Project Name': 'projektnév',
  RoleIds: 'szerepkörök',
  SizeBytes: 'fájlméret',
  TalentProfileId: 'profil',
  TIGId: 'TIG',
  UserId: 'felhasználó',
  VacationDaysTaken: 'szabadságnapok',
  WorkerId: 'dolgozó',
  Year: 'év'
};

const isObject = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null;

const tryParseJson = (value: string): unknown | undefined => {
  try {
    return JSON.parse(value);
  } catch {
    return undefined;
  }
};

const localizeFieldName = (value: string): string => {
  const fieldName = value.split('.').at(-1) ?? value;
  return fieldLabels[fieldName] ?? fieldName;
};

const translateDefaultValidationMessage = (value: string): string | undefined => {
  const hungarianNotEmptyMatch = value.match(/^A\(z\) '([^']+)' nem lehet üres\.?$/i);
  if (hungarianNotEmptyMatch) return `A(z) ${localizeFieldName(hungarianNotEmptyMatch[1])} mező kitöltése kötelező.`;

  const notEmptyMatch = value.match(/^'([^']+)' must not be empty\.?$/i);
  if (notEmptyMatch) return `A(z) ${localizeFieldName(notEmptyMatch[1])} mező kitöltése kötelező.`;

  const notNullMatch = value.match(/^'([^']+)' must not be null\.?$/i);
  if (notNullMatch) return `A(z) ${localizeFieldName(notNullMatch[1])} mező megadása kötelező.`;

  const maxLengthMatch = value.match(/^The length of '([^']+)' must be (\d+) characters or fewer\.?/i);
  if (maxLengthMatch) return `A(z) ${localizeFieldName(maxLengthMatch[1])} mező legfeljebb ${maxLengthMatch[2]} karakter lehet.`;

  const greaterThanMatch = value.match(/^'([^']+)' must be greater than '([^']+)'\.?$/i);
  if (greaterThanMatch) return `A(z) ${localizeFieldName(greaterThanMatch[1])} értékének ${greaterThanMatch[2]} fölött kell lennie.`;

  const greaterThanOrEqualMatch = value.match(/^'([^']+)' must be greater than or equal to '([^']+)'\.?$/i);
  if (greaterThanOrEqualMatch) return `A(z) ${localizeFieldName(greaterThanOrEqualMatch[1])} értéke nem lehet kisebb ${greaterThanOrEqualMatch[2]}-nál.`;

  const rangeMatch = value.match(/^'([^']+)' must be between ([^ ]+) and ([^. ]+).*$/i);
  if (rangeMatch) return `A(z) ${localizeFieldName(rangeMatch[1])} értékének ${rangeMatch[2]} és ${rangeMatch[3]} között kell lennie.`;

  const emailMatch = value.match(/^'([^']+)' is not a valid email address\.?$/i);
  if (emailMatch) return `A(z) ${localizeFieldName(emailMatch[1])} mezőben érvényes e-mail-címet adj meg.`;

  return undefined;
};

const translateMessage = (value: string): string | undefined => {
  const trimmed = value.trim();
  if (!trimmed) return undefined;

  const parsed = tryParseJson(trimmed);
  if (isObject(parsed) && typeof parsed.key === 'string') {
    const params = isObject(parsed.params) ? (parsed.params as Record<string, unknown>) : undefined;
    return backendMessages[parsed.key] ?? (t(parsed.key, params) !== parsed.key ? t(parsed.key, params) : undefined);
  }

  if (backendMessages[trimmed]) return backendMessages[trimmed];

  const translated = t(trimmed);
  if (translated !== trimmed) return translated;

  const defaultValidationMessage = translateDefaultValidationMessage(trimmed);
  if (defaultValidationMessage) return defaultValidationMessage;

  if (!/^[a-z0-9_.-]+$/i.test(trimmed)) return trimmed;

  return undefined;
};

const collectMessages = (value: unknown): string[] => {
  if (typeof value === 'string') {
    const translated = translateMessage(value);
    return translated ? [translated] : [];
  }

  if (Array.isArray(value)) return value.flatMap(collectMessages);
  if (isObject(value)) return Object.values(value).flatMap(collectMessages);

  return [];
};

const normalizePayload = (error: unknown): unknown => {
  const payload = error instanceof AxiosError ? error.response?.data : error;
  return typeof payload === 'string' ? tryParseJson(payload) ?? payload : payload;
};

const markHandled = (error: unknown) => {
  if (isObject(error)) handledErrors.add(error);
};

export const handleFailedRequest = (error: unknown) => {
  if (isObject(error) && handledErrors.has(error)) return;

  const payload = normalizePayload(error);
  const parsed = isObject(payload) ? payload : undefined;
  const errors = parsed && isObject(parsed.errors) ? parsed.errors : undefined;
  const validationSource = errors?.ValidationErrors ?? errors?.validationErrors ?? parsed?.validationErrors ?? errors;
  const validationMessages = [...new Set(collectMessages(validationSource))];

  if (validationMessages.length > 0) {
    markHandled(error);
    enqueueSnackbar(validationMessages.join(' '), { variant: 'error' });
    return;
  }

  const detail = typeof parsed?.detail === 'string' ? translateMessage(parsed.detail) : undefined;
  if (detail) {
    markHandled(error);
    enqueueSnackbar(detail, { variant: 'error' });
    return;
  }

  const status = error instanceof AxiosError ? error.response?.status : undefined;
  const fallback = status === 401
    ? 'A munkamenet lejárt. Jelentkezz be újra.'
    : status === undefined
      ? 'Nem sikerült kapcsolódni a szerverhez.'
      : 'A művelet nem hajtható végre. Ellenőrizd a megadott adatokat, majd próbáld újra.';

  markHandled(error);
  enqueueSnackbar(fallback, { variant: 'error' });
};
